import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent {

    @Input() id: string;
    @Input() label: string;
    @Input() value: string;
    @Input() type: string;
    @Input() textAreaMode: boolean;
    @Input() required: boolean;
    @Input() disabled: boolean;
    @Input() readonly: boolean;

    @Output() valueChanged: EventEmitter<string> = new EventEmitter();

    constructor() { }
}
